/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import {
  empty,
  errorResponse,
  formatDateToCustom,
  prepareResponseData,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// api
import schoolApi from "../../api/School";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import Card from "../../components/card/Card";
import { AuthContext } from "../Root/ProtectedRoute";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import colors from "../../config/colors";
import SettingsWrapper from "../../components/appWrapper/SettingsWrapper";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { FaCloudUploadAlt, FaImage, FaUserEdit } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import FullPageLoader from "../../components/loader/FullPageLoader";
import { useLocation, useNavigate } from "react-router-dom";

const SchoolProfile = ({ ...props }) => {
  const navigate = useNavigate();
  const { user: profile_data } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false); 
  const toastTR = useRef(null); // Create a reference to the hidden file input element
  const fileInputRef = useRef(null);
  const [isUploadAvatarModal, setIsUploadAvatarModal] = useState(false);
  const [avatar, setAvatar] = useState(
    !empty(profile_data) && !empty(profile_data.avatar) ? profile_data.avatar : ""
  );
  const [previewAvatar, setPreviewAvatar] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      let schoolUpdated = !empty(paramState.schoolUpdated)
        ? paramState.schoolUpdated
        : false;
      if (schoolUpdated === true) {
        paramState.schoolUpdated = false;
        responseDialog(
          "success",
          "Success",
          `School profile updated successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: {
              schoolUpdated: false,
            },
          });
        }
      }
    }
  }, []);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // Function to trigger the hidden file input click
  const handleImageFilePickUp = () => {
    fileInputRef.current.click();
  };

  // Function to handle the selected file
  const handleFileUpload = async (event) => {
    try {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        // Convert file to Base64 when the file is loaded
        reader.onloadend = async () => {
          const base64String = reader.result;
          setPreviewAvatar(base64String);
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {}
  };

  const submitAvatar = async () => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(profile_data) && !empty(profile_data._id) ? profile_data._id : "";
      const response = await schoolApi.updateUserAvatar(
        schoolId,
        previewAvatar,
        "schools"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update school avatar!"
        );
      }

      setPreviewAvatar("");
      setAvatar(previewAvatar);

      return responseDialog(
        "success",
        "Success",
        "School avatar updated successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
      setIsUploadAvatarModal(false);
    }
  };
  const initial = profile_data?.name?.charAt(0) || 'N/A';

  const updateProfile = () => {
    navigate("/update-profile");
  };

  return (
    <>
      <SettingsWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Profile" />
          {/* end menu header */}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div className="school-profile-box">
              <Card
                children={
                  <>
                    <div className="dashboard_school_list">
                      <div className="profile-avatar-container">
                        <div className="avatar-box">
                          {!empty(avatar) ? (
                            <Avatar
                              image={avatar}
                              shape="circle"
                              style={{
                                width: 200,
                                height: 200,
                                border: "4px solid " + colors.lightgray,
                                padding: 10,
                              }}
                              className="p-overlay-badge"
                            >
                              <Badge
                                style={{
                                  position: "absolute",
                                  top: 22,
                                  right: 15,
                                  width: 15,
                                  height: 15,
                                  backgroundColor: profile_data?.active
                                    ? colors.success
                                    : colors.danger,
                                }}
                                className="avatar-badge"
                              />
                            </Avatar>
                          ) : (
                            <Avatar
                              label={initial}
                              shape="circle"
                              style={{ width: 150, height: 150, fontSize: 70 }}
                              className="p-overlay-badge"
                            >
                              <Badge
                                style={{
                                  position: "absolute",
                                  top: 22,
                                  right: 22,
                                  width: 15,
                                  height: 15,
                                  backgroundColor: profile_data?.active
                                    ? colors.success
                                    : colors.danger,
                                }}
                                className="avatar-badge"
                              />
                            </Avatar>
                          )}
                        </div>
                        <div className="flex flex-center direction-row w-100pc">
                          <ButtonIcon
                            height={50}
                            marginTop={1}
                            color={colors.primary}
                            backgroundColor="transparent"
                            width={180}
                            borderColor="transparent"
                            buttonText="Update Avatar"
                            iconMarginRight={8}
                            icon={<FaCloudUploadAlt />}
                            fontWeight="bold"
                            onClick={() => setIsUploadAvatarModal(true)}
                          />
                          <ButtonIcon
                            height={50}
                            marginTop={1}
                            color={colors.primary}
                            backgroundColor="transparent"
                            width={180}
                            borderColor="transparent"
                            buttonText="Update Profile"
                            iconMarginRight={8}
                            icon={<FaUserEdit />}
                            fontWeight="bold"
                            onClick={() => updateProfile()}
                          />
                        </div>
                        <div className="avatar-container flex">
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">School Name: </div>
                              <div className="profile-value">
                                {profile_data?.name || 'N/A'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">State: </div>
                              <div className="profile-value">
                                {profile_data?.stateOfResidence || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">L.G.A: </div>
                              <div className="profile-value">
                                {profile_data?.lgaOfResidence || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Address: </div>
                              <div className="profile-value">
                                {profile_data?.address || '--'}
                              </div>
                            </div>
                          </div>

                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number 1
                              </div>
                              <div className="profile-value">
                                {profile_data?.phoneNumber1 || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number 2
                              </div>
                              <div className="profile-value">
                                {profile_data.phoneNumber2 || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">School Email</div>
                              <div className="profile-value">
                                {profile_data?.email || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Government Approved
                              </div>
                              <div className="profile-value">
                                {profile_data?.govtApproved || '--'}
                              </div>
                            </div>
                          </div>

                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Active Session:
                              </div>
                              <div className="profile-value">
                                {profile_data?.currentSessionTitle || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Active Term</div>
                              <div className="profile-value">
                                {profile_data?.currentTermTitle || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Date Registered
                              </div>
                              <div className="profile-value">
                                {formatDateToCustom(profile_data.dateCreated, true)}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Last Login</div>
                              <div className="profile-value">
                                {formatDateToCustom(profile_data.lastLogin, true)}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="other-staff-info-header mb-20">
                          <MainHeader title="Proprietor/Proprietress Details" />
                        </div>
                        <div className="flex sm-reverse-direction-vertical other-staff-info col-g-12 mb-20">
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">Title:</div>
                              <div className="profile-value">
                                {profile_data?.ownerTitle || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Name:</div>
                              <div className="profile-value">
                                {profile_data?.ownerName || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Address:</div>
                              <div className="profile-value">
                                {profile_data?.ownerAddress || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Origin:
                              </div>
                              <div className="profile-value">
                                {profile_data?.stateOfOrigin || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Origin:
                              </div>
                              <div className="profile-value">
                                {profile_data?.lgaOfOrigin || '--'}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Residence:
                              </div>
                              <div className="profile-value">
                                {profile_data?.ownerStateOfResidence || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Residence:
                              </div>
                              <div className="profile-value">
                                {profile_data?.ownerLgaOfResidence || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Email:</div>
                              <div className="profile-value">
                                {profile_data?.ownerEmail || '--'}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Phone Number:</div>
                              <div className="profile-value">
                                {profile_data?.ownerPhone || '--'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                }
                addStyle="student_list_box"
              />
              {/* end chart */}

              {/*  */}
            </div>
            {/* end of left box */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
        {isLoading && <FullPageLoader visible={isLoading} />}
      </SettingsWrapper>

      <Dialog
        visible={isUploadAvatarModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Action"
        modal
        onHide={() => {
          setPreviewAvatar("");
          setIsUploadAvatarModal(false);
        }}
      >
        <div
          className="confirmation-content"
          style={{
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="avatar-preview-box mb-20">
            {!empty(previewAvatar) ? (
              <img src={previewAvatar} alt="" />
            ) : (
              <FaCloudUploadAlt size={80} />
            )}
          </div>
          {<span>Select image to upload</span>}

          <div className="flex flex-center w-100pc col-g-12">
            <ButtonIcon
              height={40}
              marginTop={1}
              color={colors.tomato}
              backgroundColor={colors.lightgray}
              width={180}
              fontSize={14}
              borderColor={colors.lightgray}
              buttonText="Select Avatar"
              iconMarginRight={8}
              icon={<FaImage size={18} />}
              fontWeight="bold"
              onClick={handleImageFilePickUp}
            />
            {previewAvatar ? (
              <ButtonIcon
                height={40}
                marginTop={1}
                color={colors.primary}
                backgroundColor={colors.lightgray}
                width={180}
              fontSize={14}
                borderColor={colors.lightgray}
                buttonText="Update Avatar"
                iconMarginRight={8}
                icon={<FaCloudUploadAlt size={18}  />}
                fontWeight="bold"
                onClick={() => submitAvatar()}
              />
            ) : null}
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileUpload}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default SchoolProfile;
